import { Helmet } from 'react-helmet-async';

const SEO = ({
    title,
    description,
    keywords,
    image,
    robots,
    canonical,
    children
}) => {
    const seo = {
        title: title || 'BoleumLearn - Transform your career with expert-led online training',
        description: description || 'Master new skills with BoleumLearn. Access premium courses, expert instructors, and flexible learning paths for students and professionals.',
        keywords: keywords || 'online learning, onilne, training, oil & gas training, technical courses, advanced course, courses, e-learning platform, skill development, education',
        image: image || 'https://boleum.com/static/media/boleumlogo.f78456cd4efb8df28665.png',
        robots: robots || 'index, follow',
        canonical: canonical
    };

    return (
        <Helmet>
            <title>{seo.title}</title>
            <meta name="description" content={seo.description} />
            <meta name="keywords" content={seo.keywords} />
            <meta name="robots" content={seo.robots} />

            {seo.canonical && <link rel="canonical" href={seo.canonical} />}

            <meta property="og:type" content="website" />
            <meta property="og:title" content={seo.title} />
            <meta property="og:description" content={seo.description} />
            <meta property="og:image" content={seo.image} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:image:alt" content={seo.title} />
            {seo.canonical && <meta property="og:url" content={seo.canonical} />}
            <meta property="og:site_name" content="BoleumLearn" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={seo.title} />
            <meta name="twitter:description" content={seo.description} />
            <meta name="twitter:image" content={seo.image} />
            <meta name="twitter:image:alt" content={seo.title} />
            <meta name="twitter:site" content="@boleumlearn" />

            <meta name="theme-color" content="#ffffff" />

            {children}
        </Helmet>
    );
};

export default SEO;